export enum OrientationEnum {
	VERTICAL = 'vertical',
	HORIZONTAL = 'horizontal',
}

export type OrientationEnumType = OrientationEnum;
